import { useMocks } from '../../shared/env';
import type { PeopleGateway } from './PeopleGateway';
import { HttpPeopleGateway } from './HttpPeopleGateway';
import { MockPeopleGateway } from './MockPeopleGateway';

export const peopleGateway: PeopleGateway = useMocks ? new MockPeopleGateway() : new HttpPeopleGateway();

// Mock mode only: lets a browser test (Playwright) pick the synthetic situation the read-only State Income Tax panel shows. Never present when the real
// gateway is in use.
if (useMocks && typeof window !== 'undefined') {
  (window as unknown as { __epnMockPeople?: PeopleGateway }).__epnMockPeople = peopleGateway;
}
export type { PeopleGateway } from './PeopleGateway';
export { listAllEmployees } from './listAllEmployees';
